/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated do not edit it manually",
 */
import React from "react";

import { youtube } from "../assets/youtube";
import { Icon, type IconBaseProps } from "../icon";

export const IconYoutube = (props: IconBaseProps) => <Icon {...props} svg={youtube} />;

IconYoutube.displayName = "IconYoutube";
